(() => {
  const form = document.getElementById('cb-duo-form');
  if (!form) return;
  form.addEventListener('submit', async event => {
    event.preventDefault();
    const button = form.querySelector('button');
    if (button.disabled) return;
    const status = document.getElementById('cb-duo-status');
    const items = [...form.querySelectorAll('select')].map(select => ({id:select.value,quantity:1}));
    button.disabled = true;
    status.textContent = form.dataset.loading;
    try {
      const response = await fetch(form.action + '.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || form.dataset.error);
      window.location.assign(form.dataset.cart);
    } catch (error) {
      status.textContent = error.message || form.dataset.error;
      button.disabled = false;
    }
  });
})();
